export default  function toDefaultcurrency(amount,currencyValue)  {
    return (amount/currencyValue).toFixed(8)
  }